// Shift creation 共通ヘルパー (関数とフック)
import { useEffect, useState } from "react";

export function hoursOf(s) {
  if (!s?.start_time || !s?.end_time) return 0;
  const [sh, sm] = s.start_time.split(":").map(Number);
  const [eh, em] = s.end_time.split(":").map(Number);
  let mins = (eh * 60 + em) - (sh * 60 + sm);
  if (mins < 0) mins += 24 * 60;
  return mins / 60;
}

export const fmtH = (h) => !h ? "0h" : (Number.isInteger(h) ? `${h}h` : `${h.toFixed(1)}h`);

// `lg` (>=1024px) 以上を PC 表示と判定
export function useIsDesktop() {
  const [isDesktop, setIsDesktop] = useState(() =>
    typeof window !== "undefined" ? window.matchMedia("(min-width: 1024px)").matches : true
  );
  useEffect(() => {
    if (typeof window === "undefined") return;
    const mq = window.matchMedia("(min-width: 1024px)");
    const onChange = (e) => setIsDesktop(e.matches);
    mq.addEventListener ? mq.addEventListener("change", onChange) : mq.addListener(onChange);
    return () => {
      mq.removeEventListener ? mq.removeEventListener("change", onChange) : mq.removeListener(onChange);
    };
  }, []);
  return isDesktop;
}

export const nameOf = (map, uid) => map[uid]?.display_name || map[uid]?.name || "?";

export function deriveDayStatus(sm) {
  if (!sm) return { label: "", tone: "slate" };
  if (sm.diff_vs_desired !== null && sm.diff_vs_desired !== undefined) {
    if (sm.diff_vs_desired >= 2) return { label: "希望より多め", tone: "purple" };
    if (sm.diff_vs_desired === 1) return { label: "希望+1", tone: "slate" };
    if (sm.diff_vs_desired === 0) return { label: "希望ぴったり", tone: "green" };
    if (sm.diff_vs_desired < 0) return { label: "希望より少なめ", tone: "blue" };
  }
  return { label: "", tone: "slate" };
}
